import React, {useEffect, useState} from 'react';
import {Card, Col, Row} from "react-bootstrap-v5";
import T from "i18n-react";
import IndicatorValue from "../../../components/card-indicator/indicator-value";
import I18NController from "../../../utils/i18n/i18n-controller";
import {connect} from "react-redux";
import OverlayLoadingOrError from "../../../components/overlay-component/overlay-loading-or-error";
import {lotService} from "../../../services/lot-service";

const CardLotIndicators = ({lotId, className, currentUser, progress}) => {
    const [state, setState] = useState({isLoading: false, error: ''});
    const [indicatorCost, setIndicatorCost] = useState('');

    useEffect(() => {
        const getIndicators = async () => {
            try {
                setState({isLoading: true, error: ''});
                const indicator = await lotService.indicatorsAnalysesCostForLot(lotId);
                setIndicatorCost(I18NController.getInstance().formatPrice(indicator.sumOfControlPrice, currentUser.currency, currentUser.language));
                setState({isLoading: false, error: ''});
            } catch (error) {
                setState({isLoading: false, error: error.message})
            }
        }

        getIndicators();
    }, [lotId, currentUser, progress]);

    return (
        <Card className={`card-lot-indicators ${className}`}>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <Card.Title className="m-0">{T.translate('title.indicators')}</Card.Title>
            </Card.Header>
            <Card.Body>
                <Row className="m-0 px-2 gx-4 h-100 justify-content-center">
                    <Col className="mb-4"></Col>
                    <Col className="mb-4">
                        <IndicatorValue title={T.translate('indicators.analysesCosts')} currentYear={indicatorCost}/>
                    </Col>
                </Row>
            </Card.Body>
            <OverlayLoadingOrError isLoading={state.isLoading} error={state.error}/>
        </Card>
    );
};

const mapStateToProps = state => {
    return {
        currentUser: state.authReducer.currentUser
    }
}

export default connect(mapStateToProps)(CardLotIndicators);
